import get from 'lodash.get'
import ToastAlert from 'components/ToastAlert/ToastAlert'
import { AuthService } from '../utils/auth'
import { getApiCallSequenceSteps } from 'utils/misc'
import { history } from 'components/CustomBrowserRouter/CustomBrowserRouter'
import { HTTP_RESPONSE_CODE_TOKEN_INVALID } from './constants'
import { SEQUENCE_STEPS } from 'utils/constants'
import { TGetAPISecuenceStepsByResourceName } from './interface'
import { TSecuenceSteps, TSecuenceStepsAll } from 'utils/interface'

const T_ROOT = 'session'
const T_ROOT_TOAST = `${T_ROOT}.error`
const T_ROOT_TOAST_ERROR = `${T_ROOT_TOAST}.toastAlert`

export const catchError = (data: any, dispatch: any, type: string) => {
  dispatch({ type, data })
  removeSessionIfTokenHasExpired(data)
}

export const removeSessionIfTokenHasExpired = (error: any): void => {
  const authService = AuthService.getInstance()
  const RESPONSE_STATUS = get(error, 'response.status', false)

  if (RESPONSE_STATUS && RESPONSE_STATUS === HTTP_RESPONSE_CODE_TOKEN_INVALID) {
    if (authService.hasTokenExpired()) {
      authService.removeSessionInfo()
    } else {
      ToastAlert({
        text: `${T_ROOT_TOAST_ERROR}.text`,
        title: `${T_ROOT_TOAST_ERROR}.title`,
        type: 'error',
        useTKey: true
      })
    }
    if (!location.pathname.endsWith('dashboard')) {
      history.push('/')
    }
  }
}

export const getAPISecuenceStepsByResourceName = (resourceName: string): TGetAPISecuenceStepsByResourceName => {
  const TYPES: TSecuenceStepsAll = { ...getApiCallSequenceSteps(resourceName) }
  const keys = Object.keys(TYPES) as TSecuenceSteps[]
  const FAILED = keys.find(i => TYPES[i].includes(SEQUENCE_STEPS[2])) || ''
  const REQUESTED = keys.find(i => TYPES[i].includes(SEQUENCE_STEPS[0])) || ''
  const RESET = keys.find(i => TYPES[i].includes(SEQUENCE_STEPS[3])) || ''
  const SUCCESSFUL = keys.find(i => TYPES[i].includes(SEQUENCE_STEPS[1])) || ''

  return {
    failed: FAILED,
    requested: REQUESTED,
    reset: RESET,
    successful: SUCCESSFUL
  }
}
